import React from "react";
import appLib from "../libs/appLib.mjs";

const G = window.glob;

const IncomingMessagesChecker = class extends React.Component {
	constructor(props) {
		super(props);
		const player = G.getStatus('Player');
		this.state = {
			player: player?.id,
			isAdmin: player?.admin,
			lastGame: 0,
			lastMail: 0,
			lastIm: 0,
			lastNotice: 0
		};
		this.uid = G.generateUid("IncomingMessagesChecker");
		this.check = this.check.bind(this);
		this.reset = this.reset.bind(this);
	}

	componentDidMount() {
		G.register( "Game",(gd) => { this.check(gd); }, this.uid );
		G.register('Player', p => {
			this.setState({ player: p?.id, isAdmin: p?.admin });
		}, this.uid);
		G.register( "ForceCheckReceived", ()=>{
			setTimeout( ()=>{ this.check(G.getStatus("Game"), true); });
		}, this.uid);
		setTimeout( ()=>{ this.check(G.getStatus("Game") ); });
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	reset() {
		this.setState({
			lastMail: 0,
			lastIm: 0,
			lastGame: 0,
			lastNotice: 0
		});
		G.trigger("ImReceived", { lastupdate: {}, data: {} } );
		G.trigger("MailReceived", [] );
	}
	check(gd, force=false) {
		const pid = G.getStatus('Player')?.id;
		if ( ! pid ) return this.reset();
		if ( pid !== this.state.player ) {
			this.setState({ player: pid });
			force = true;
		}
		const lu = gd?.lastupdate;
		if (!lu) return this.reset();
		if (! force && this.state.lastGame >= lu) return;
		this.setState({lastGame: lu});
		const mail = appLib.mailByPlayer();
		const im = appLib.imByPlayer();
		let lastTime = this.state.lastIm;
		Object.entries(im.lastupdate).forEach(([k, v]) => {
			if (v > lastTime) lastTime = v;
		});
		if (!force && lastTime > this.state.lastIm) {
			this.setState({lastIm: lastTime});
			G.trigger("NewImReceived", { lastupdate: lastTime, data: im} );
		}
		lastTime = this.state.lastMail;
		Object.entries(mail.lastupdate).forEach(([k, v]) => {
			if (v > lastTime) lastTime = v;
		});
		if (! force && lastTime > this.state.lastMail) {
			this.setState({lastMail: lastTime});
			G.trigger("NewMailReceived", mail);
		}
		if ( this.state.isAdmin ) {
			const notices = gd.notice ?? [];
			lastTime = notices.find( n => n?.time && n.time > this.state.lastNotice)?.time;
			if ( lastTime ) {
				this.setState({lastNotice: lastTime});
				G.trigger("NewNotice", notices);
			}
		}
	}

	render() {
		return (
			<div
				className={"IncomingMessagesChecker"}
				id={this.uid}
				hidden={true}
				lastmail={this.state.lastMail}
				lastim={this.state.lastIm}
				lastgame={this.state.lastGame}
			/>
		);
	}
};

export default IncomingMessagesChecker;
